<mat-sidenav-container class="layout-container">
  <mat-sidenav #sidenav class="sidenav" [mode]="'side'" [(opened)]="opened">
    <div class="brand">
      <img
        src="../../../../../assets/images/Sachacabrona-removebg-preview.png"
        alt="Logo"
        class="brand-logo"
      />
      <h3 class="brand-title" *ngIf="opened">{{ empresa }}</h3>
    </div>

    <mat-divider></mat-divider>

    <mat-nav-list>
      <a mat-list-item routerLink="/admin/inicio" routerLinkActive="active">
        <mat-icon>home</mat-icon>
        <span>Inicio</span>
      </a>

      <a mat-list-item routerLink="/admin/pedidos" routerLinkActive="active">
        <mat-icon>receipt_long</mat-icon>
        <span *ngIf="opened">Pedidos</span>
      </a>

      <a mat-list-item routerLink="/admin/parametros" routerLinkActive="active">
        <mat-icon>settings_applications</mat-icon>
        <span *ngIf="opened">Parámetros</span>
      </a>

      <a mat-list-item routerLink="/admin/productos" routerLinkActive="active">
        <mat-icon>fastfood</mat-icon>
        <span *ngIf="opened">Productos</span>
      </a>

      <!-- <a mat-list-item routerLink="/admin/calendario" routerLinkActive="active">
        <mat-icon>today</mat-icon>
        <span *ngIf="opened">Calendario</span>
      </a> -->
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <header class="header">
      <button mat-icon-button (click)="toggleSidenav()">
        <mat-icon>{{ opened ? "menu_open" : "menu" }}</mat-icon>
      </button>

      <h1 class="header-title">Panel de control</h1>

      <span class="spacer"></span>

      <button mat-icon-button (click)="toggleTheme()">
        <mat-icon>{{ darkMode ? "dark_mode" : "light_mode" }}</mat-icon>
      </button>

      <button mat-icon-button [matMenuTriggerFor]="menuNotificaciones">
        <mat-icon>notifications</mat-icon>
        <p style="position: absolute; top: 10px; right: 3px">
          {{ notificaciones.length }}
        </p>
      </button>

      <mat-menu #menuNotificaciones="matMenu" class="menu-notificaciones">
        <ng-container
          *ngIf="(notificaciones?.length ?? 0) > 0; else noNotificaciones"
        >
          <button
            mat-menu-item
            *ngFor="let n of notificaciones"
            class="notificacion-item"
          >
            <mat-icon>notifications_active</mat-icon>

            <div class="notificacion-content">
              <div class="titulo">Nueva solicitud</div>
              <div class="fecha">
                {{ n.createdAt | date: "dd/MM/yyyy HH:mm" }}
              </div>
            </div>
          </button>
        </ng-container>

        <ng-template #noNotificaciones>
          <button mat-menu-item disabled>
            <mat-icon>info</mat-icon>
            <span>No hay notificaciones</span>
          </button>
        </ng-template>
      </mat-menu>

      <button mat-icon-button [matMenuTriggerFor]="menuCuenta">
        <mat-icon>account_circle</mat-icon>
      </button>

      <mat-menu #menuCuenta="matMenu">
        <button mat-menu-item (click)="irAMiPerfil()">
          <mat-icon>person</mat-icon>
          <span>Mi perfil</span>
        </button>

        <button mat-menu-item (click)="cerrarSesion()">
          <mat-icon>logout</mat-icon>
          <span>Cerrar sesión</span>
        </button>
      </mat-menu>
    </header>

    <div class="content-area">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
